import styled from "styled-components";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";

export const CCPCollectionsWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-left: -7px;
    min-height: 34px;
    align-items: center;

    @media print {
        display: none;
    }
`;

export const CCPCollectionBadge = styled.div<{ $noCta: boolean }>`
    border-radius: 100px;
    background: ${({ theme }) => theme ? theme.v3.colors.grey96 : null};
    width: auto;
    margin: 5px 7px;
    display: flex;
    align-items: center;
    
    svg {
        &:hover {
            stroke: ${({ theme }) => theme ? theme.v3.colors.red : null};
        }
    }

    > div {
        cursor: pointer;
        display: inline-flex;

        &:first-child {
            padding: ${({ $noCta }) => $noCta ? "4px" : " 4px 4px 4px 8px"};

            &:hover {
                ${V3CaptionGrey35} {
                    color: ${({ theme }) => theme ? theme.v3.colors.blue : null};
                }
            }
        }

        &:nth-child(2) {
            padding: 4px 8px 4px 0px;
            padding-left: 4px;

            &:hover {
                svg {
                    path {
                        stroke:  ${({ theme }) => theme ? theme.v3.colors.red : null};
                    }
                }
            }
        }
    }
`;